<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="邀請計費輔導"
    cancelBtnText="取消"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <span class="subheading">{{dialogText}}</span>
    <template slot="action">
      <v-btn
        v-show="showCancelInvtieBtn"
        @click="cancelInvite"
        flat>
        取消邀請
      </v-btn>
    </template>
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '是否開始計費輔導?',
    showConfirmBtn: true,
    showCancelBtn: true,
    showCancelInvtieBtn: false,
    fudaoDto: {}
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      responseTimeout: state => state.responseTimeout
    })
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    }
  },

  mounted() {
    this.$eventBus.$on('teacher-invite-fudao-dialog', this.open);
  },

  beforeDestory() {
    this.$eventBus.$off('teacher-invite-fudao-dialog', this.open);
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    ...mapActions('fudao', {
      inviteFudao: 'inviteFudao'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoDto.id && this.fudaoDto.id !== domainEvent.body.id;
    },

    open() {
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.TeacherStartInvitationSent, this.onTeacherStartInvitationSent);
      // this.$eventBus.$off(FudaoEvent.StudentStartInvitationReceived, this.onStudentStartInvitationReceived);
      this.$eventBus.$off(FudaoEvent.StudentStartInvitationAccepted, this.onStudentStartInvitationAccepted);
      this.$eventBus.$off(FudaoEvent.StudentStartInvitationRejected, this.onStudentStartInvitationRejected);
      this.$eventBus.$off(FudaoEvent.StudentStartInvitationNoResponse, this.onStudentStartInvitationNoResponse);
      this.$eventBus.$off(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      clearTimeout(this._timeout);
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      this.loading = true;
      this.$eventBus.$on(FudaoEvent.TeacherStartInvitationSent, this.onTeacherStartInvitationSent);
      // this.$eventBus.$on(FudaoEvent.StudentStartInvitationReceived, this.onStudentStartInvitationReceived);
      this.$eventBus.$on(FudaoEvent.StudentStartInvitationAccepted, this.onStudentStartInvitationAccepted);
      this.$eventBus.$on(FudaoEvent.StudentStartInvitationRejected, this.onStudentStartInvitationRejected);
      this.$eventBus.$on(FudaoEvent.StudentStartInvitationNoResponse, this.onStudentStartInvitationNoResponse);
      this.$eventBus.$on(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      this.fudaoDto = await this.inviteFudao();

      // 開始倒數無回應
      this._timeout = setTimeout(() => {
        this.sentNoResponse();
      }, this.responseTimeout);
    },

    cancel() {
      this.dialog = false;
    },

    async cancelInvite() {
      clearTimeout(this._timeout);
      await fudaoAppService.cancelFudaoAsync(this.fudaoDto.id);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseFudaoAsync(this.fudaoDto.id);
    },

    // events -------------------------------------

    onTeacherStartInvitationSent(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.fudaoDto = domainEvent.body;
      this.dialogText = '已送出邀請，等待對方回應...';
      this.showConfirmBtn = false;
      this.showCancelBtn = false;
      this.showCancelInvtieBtn = true;
    },

    // onStudentStartInvitationReceived(domainEvent) {
    // },

    async onStudentStartInvitationAccepted(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }

      clearTimeout(this._timeout);
      let result = await fudaoAppService.startFudaoAsync(this.fudaoDto.id);
      if (!result) {
        this.addAlert({level: 'error', content: '建立輔導連線失敗'});
      }
      this.dialog = false;
    },

    onStudentStartInvitationRejected(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '學生拒絕輔導邀請'});
      this.dialog = false;
    },

    onStudentStartInvitationNoResponse(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '邀請輔導無回應'});
      this.dialog = false;
    },

    onFudaoStartFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請輔導發生錯誤: ' + errMsg});
    }
  }
};
</script>